module.exports = __webpack_public_path__ + "img/p4-c2-p2.76875ff9.jpg";